var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#78A6BE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1402_9550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8C17.6266 8 15.3066 8.70379 13.3332 10.0224C11.3598 11.3409 9.8217 13.2151 8.91345 15.4078C8.0052 17.6005 7.76756 20.0133 8.23058 22.3411C8.6936 24.6689 9.83649 26.8071 11.5147 28.4853C13.193 30.1635 15.3312 31.3064 17.6589 31.7694C19.9867 32.2324 22.3995 31.9948 24.5922 31.0866C26.7849 30.1783 28.6591 28.6402 29.9776 26.6668C31.2962 24.6935 32 22.3734 32 20C31.9966 16.8185 30.7312 13.7682 28.4815 11.5185C26.2318 9.26883 23.1815 8.00344 20 8V8ZM20 30C18.0222 30 16.0888 29.4135 14.4443 28.3147C12.7998 27.2159 11.5181 25.6541 10.7612 23.8268C10.0043 21.9996 9.8063 19.9889 10.1922 18.0491C10.578 16.1093 11.5304 14.3275 12.9289 12.9289C14.3275 11.5304 16.1093 10.578 18.0491 10.1921C19.9889 9.8063 21.9996 10.0043 23.8268 10.7612C25.6541 11.5181 27.2159 12.7998 28.3147 14.4443C29.4135 16.0888 30 18.0222 30 20C29.9971 22.6513 28.9426 25.1931 27.0679 27.0679C25.1931 28.9426 22.6513 29.9971 20 30ZM21 19H25V21H21V25H19V21H15V19H19V15H21V19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1402_9550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.7925865f4d90135fdb391fea123ae599.svg";
export { ForwardRef as ReactComponent };